module.exports = __webpack_public_path__ + "img/blueBoxTopLeft.7ca4220c.svg";